import React from 'react';
import { AlertTriangle, Database, FileWarning, Ban, ArrowRight } from 'lucide-react';
import { problemData, contactData } from '../../data/mock';

const ProblemSection = () => {
  const icons = [Database, Ban, FileWarning];

  return (
    <section id="problema" className="py-20 md:py-28 bg-slate-900 relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-400 via-emerald-500 to-amber-400" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-slate-800 rounded-full blur-3xl opacity-50" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-400/10 border border-amber-400/20 rounded-full mb-6">
            <AlertTriangle className="w-4 h-4 text-amber-400" />
            <span className="text-amber-400 text-sm font-semibold">Entenda o Problema</span>
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            {problemData.title}
          </h2>
          
          <p className="text-lg text-slate-400 leading-relaxed">
            {problemData.description}
          </p>
        </div>

        {/* Problem Cards */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 mb-16">
          {problemData.points.map((point, index) => {
            const Icon = icons[index];
            return (
              <div
                key={index}
                className="group p-6 md:p-8 bg-slate-800/50 backdrop-blur border border-slate-700/50 rounded-2xl hover:border-amber-400/30 transition-all duration-300"
              >
                <div className="w-14 h-14 bg-amber-400/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-amber-400/20 transition-colors duration-300">
                  <Icon className="w-7 h-7 text-amber-400" />
                </div>
                
                <h3 className="text-xl font-bold text-white mb-3">
                  {point.title}
                </h3>
                
                <p className="text-slate-400 leading-relaxed">
                  {point.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Highlight Quote */}
        <div className="relative max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-slate-800 to-slate-800/50 border border-slate-700 rounded-2xl p-8 md:p-12">
            <div className="flex items-start gap-4">
              <div className="hidden sm:block w-1 h-full min-h-[60px] bg-amber-400 rounded-full" />
              <blockquote className="text-xl md:text-2xl lg:text-3xl font-semibold text-white leading-relaxed">
                "{problemData.highlight}"
              </blockquote>
            </div>
          </div>
          
          {/* CTA after quote */}
          <div className="mt-8 text-center">
            <a
              href={contactData.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-amber-400 hover:bg-amber-300 text-slate-900 font-semibold px-8 py-4 rounded-xl transition-all duration-300 shadow-lg shadow-amber-400/20 hover:shadow-xl hover:shadow-amber-400/30"
            >
              <span>Descobrir o que está errado no meu crédito</span>
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
